import { render, staticRenderFns } from "./Mammogram.vue?vue&type=template&id=5132733f"
import script from "./Mammogram.vue?vue&type=script&lang=js"
export * from "./Mammogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports